/** Color scale for location occupancy density on warehouse layout */

export function maxLocationQty(
  nodes: Array<{ occupancy?: { totalQty: number } | null }>,
): number {
  let max = 0;
  for (const n of nodes) {
    const q = n.occupancy?.totalQty ?? 0;
    if (q > max) max = q;
  }
  return max;
}

/** Fill color: empty → light; denser qty → stronger primary mix */
export function locationDensityFill(opts: {
  totalQty: number;
  maxQty: number;
  isDefaultReceive: boolean;
  customColor?: string | null;
}): string {
  if (opts.customColor) return opts.customColor;
  const qty = opts.totalQty;
  if (qty <= 0) {
    return opts.isDefaultReceive
      ? "color-mix(in oklab, var(--primary) 12%, white)"
      : "var(--background)";
  }
  const t = Math.min(1, qty / Math.max(opts.maxQty, 1));
  const pct = Math.round(22 + t * 55);
  return `color-mix(in oklab, var(--primary) ${pct}%, white)`;
}
